import { promotions } from '@/mocks/data';

export default function PromotionSection() {
  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            优惠活动
          </h2>
          <p className="text-sm text-foreground-500 mt-2">丰厚奖励助您畅享体育博彩体验</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {promotions.map((promo) => (
            <div
              key={promo.id}
              className="relative bg-background-50 border border-background-200/70 rounded-lg overflow-hidden group cursor-pointer"
            >
              <div className="relative h-36">
                <img
                  src={promo.imageUrl}
                  alt={promo.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent"></div>
                <span className="absolute top-3 right-3 px-3 py-1 bg-accent-500 text-foreground-950 text-xs font-bold rounded-full">
                  {promo.badge}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-base font-semibold text-foreground-900 mb-2">{promo.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">{promo.description}</p>
                <button className="mt-4 px-5 py-2 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                  立即参与
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}